const images = {
    LoginBackgroundImage: './pages/Login/backgroundImage.png'
};
export default images;
